import { Route, Routes } from "react-router-dom";

import Form from "./Form";
import Overview from "./Overview";
import Product from "./Product";

const New = () => {
  return (
    <Routes>
      <Route path="/" element={<Product />} />
      <Route path="/:type/overview" element={<Overview />} />
      <Route path="/:type/form" element={<Form />} />
    </Routes>
  );
};

export default New;
